import {axios} from '@/utils/axios';

const RESOURCE_NAME = '/accounting/documents/salary-charge';

export default {
    fill_by_all(payload) {
        return axios.post(`${RESOURCE_NAME}/fill-by-all`, payload)
    },
    start_info(payload) {
        return axios.get(`${RESOURCE_NAME}/start-info`, {params: payload})
    },
    get_document_by_id(id) {
        return axios.post(`${RESOURCE_NAME}/get-document-by-id`, {document_id: id})
    },
    person_indexation(payload) {
        return axios.get(`${RESOURCE_NAME}/person-indexation`, {params: payload})
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { "delete_id": payload })
    },
    conducted(payload) {
        return axios.post(`${RESOURCE_NAME}/conducted`, payload)
    },
};